import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import { formatSponsorNames } from '../../../../pages/Events/SingleEvent/SingleEvent';
import Pixel, {
    EmitMetric,
} from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import FGBLabel from '../../../Elements/FGBLabel/FGBLabel';
import { eventPropTypesShape } from '../../../Includes/eventsProps';
import Button from '../../../Input/Button/Button';
import {
    formatHourInAMPMFormat,
    getDateFromISO,
    getMonthFromISO,
    getUserLocalTimeZone,
} from '../../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../../EventRegisterButton/EventRegisterButtonContainer';
import WithRegisterStateManager from '../../WithRegisterStateManager/WithRegisterStateManager';

import DateDisplay from './DateDisplay/DateDisplay';

import './SingleEventComponent.scss';
import SingleEventImageDisplaySection from './SingleEventImageDisplaySection/SingleEventImageDisplaySection';

export class SingleEventComponent extends React.PureComponent {
    static propTypes = {
        /**
         * single event data
         */
        event: eventPropTypesShape.isRequired,
        /**
         * whether render event as card style
         */
        cardStyling: PropTypes.bool,
        /**
         * whether render event as compact style
         */
        compactSize: PropTypes.bool,
        /**
         * whether user is register for the event or not
         */
        isUserRegistered: PropTypes.bool.isRequired,
        /**
         * wrap component with a layer that require authentications
         */
        wrapAuth: PropTypes.func.isRequired,
        /**
         * set userRegistered to true
         */
        setUserAsRegistered: PropTypes.func.isRequired,
    };

    static defaultProps = {
        event: {},
        setUserAsRegistered: () => {},
        compactSize: false,
        cardStyling: true,
    };

    handleViewEventClick = () => {
        const {
            event: { id, sponsors },
        } = this.props;
        const sponsorIds = sponsors.map((company) => company.companyId);
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'event-view-event-click',
            event_id: id,
            company_id: sponsorIds,
        });
    };

    render() {
        const {
            compactSize,
            cardStyling,
            isUserRegistered,
            setUserAsRegistered,
            wrapAuth,
            event,
        } = this.props;
        const {
            id,
            sponsors,
            eventType,
            title,
            startTime,
            endTime,
            image,
            label,
            viewUrl,
            registrationUrl,
            isFeatured,
            authenticationRequired,
        } = event;
        const startTimeFormatted = formatHourInAMPMFormat(startTime);
        const endTimeFormatted = formatHourInAMPMFormat(endTime);
        const timeZone = getUserLocalTimeZone();
        const month = getMonthFromISO(startTime);
        const day = getDateFromISO(startTime);
        const compactSizeStyle = compactSize ? 'compact' : '';
        const cardStyle = cardStyling ? 'card-style' : '';
        const sponsorIds = sponsors.map((company) => company.companyId);
        const impressionMetrics = {
            misc_event_count: 1,
            misc_event_type: 'event-view-impression',
            event_id: id,
            company_id: sponsorIds,
        };

        const hasSponsors = sponsors && sponsors.length > 0;

        return (
            <div
                className={`component-Events-SingleEventComponent ${compactSizeStyle} ${cardStyle}`}
            >
                <Pixel metrics={impressionMetrics} />
                <section className="width-controller-div">
                    <DateDisplay
                        isFeatured={isFeatured}
                        month={month}
                        day={day}
                    />
                    <div className={'singleEventCard-info-display'}>
                        <FGBLabel className={'event-type-label-display'}>
                            {eventType}
                        </FGBLabel>
                        <div className="singleEvent-title-display">{title}</div>

                        <NoSSR>
                            <FGBLabel
                                className={'time-frame-display'}
                            >{`${startTimeFormatted} - ${endTimeFormatted} ${timeZone}`}</FGBLabel>
                        </NoSSR>

                        <SingleEventImageDisplaySection
                            className="mobile-image-section"
                            image={image}
                            sponsors={sponsors}
                        />
                        {hasSponsors ? (
                            <div className="single-event-host-label-display">
                                {`${label} ${formatSponsorNames(sponsors)}`}
                            </div>
                        ) : null}
                        <section className="button-section">
                            <EventRegisterButtonContainer
                                event={event}
                                isUserRegistered={isUserRegistered}
                                setUserAsRegistered={setUserAsRegistered}
                            />
                            <div className="viewEvent-button-div">
                                {authenticationRequired === 1 ? (
                                    wrapAuth(
                                        'ViewEvent',
                                        <a
                                            onClick={this.handleViewEventClick}
                                            href={viewUrl}
                                            target={
                                                registrationUrl
                                                    ? '_self'
                                                    : '_blank'
                                            }
                                            rel="noopener noreferrer"
                                        >
                                            <Button
                                                type={'secondary-blue-gray'}
                                                value={'View Event'}
                                            />
                                        </a>,
                                        { login_trigger: 'view-event' }
                                    )
                                ) : (
                                    <a
                                        onClick={this.handleViewEventClick}
                                        href={viewUrl}
                                        target={
                                            registrationUrl ? '_self' : '_blank'
                                        }
                                        rel="noopener noreferrer"
                                    >
                                        <Button
                                            type={'secondary-blue-gray'}
                                            value={'View Event'}
                                        />
                                    </a>
                                )}
                            </div>
                        </section>
                    </div>
                    <SingleEventImageDisplaySection
                        className="desktop-image-section"
                        desktopView
                        image={image}
                        sponsors={sponsors}
                    />
                </section>
            </div>
        );
    }
}

export default WithRegisterStateManager((props) => (
    <PageConsumer>
        {({ wrapAuth }) => (
            <SingleEventComponent {...props} wrapAuth={wrapAuth} />
        )}
    </PageConsumer>
));
